(function () {
  function getDrawer(element) {
    return element.closest('.skim1-mini-cart');
  }

  function closePanels(drawer) {
    if (!drawer) return;

    drawer.querySelectorAll('[data-skim1-cart-panel]').forEach((panel) => {
      panel.hidden = true;
    });

    drawer.querySelectorAll('[data-skim1-cart-panel-trigger]').forEach((trigger) => {
      trigger.classList.remove('is-active');
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function openPanel(drawer, panelName, trigger) {
    if (!drawer) return;

    const panel = drawer.querySelector(`[data-skim1-cart-panel="${panelName}"]`);
    if (!panel) return;

    const isOpen = !panel.hidden;
    closePanels(drawer);

    if (!isOpen) {
      panel.hidden = false;
      if (trigger) {
        trigger.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
      }
    }
  }

  function getShopifyRoute(path) {
    const root = window.Shopify?.routes?.root || '/';
    return `${root.endsWith('/') ? root : `${root}/`}${path.replace(/^\//, '')}`;
  }

  function setShippingResult(form, html) {
    const result = form.querySelector('[data-skim1-shipping-result]');
    if (result) result.innerHTML = html;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (character) => {
      const entities = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      };
      return entities[character];
    });
  }

  function formatShippingRate(rate) {
    const currency = rate.currency || rate.currency_code || '';
    const price = rate.price || rate.presentment_price || '';
    return `${price}${currency ? ` ${currency}` : ''}`;
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-skim1-cart-panel-trigger]');
    if (trigger) {
      const drawer = getDrawer(trigger);
      openPanel(drawer, trigger.dataset.skim1CartPanelTrigger, trigger);
      return;
    }

    const closeButton = event.target.closest('[data-skim1-cart-panel-close]');
    if (closeButton) {
      closePanels(getDrawer(closeButton));
    }
  });

  document.addEventListener('submit', (event) => {
    const shippingForm = event.target.closest('[data-skim1-shipping-form]');
    if (shippingForm) {
      event.preventDefault();

      const country = shippingForm.querySelector('[name="shipping_address[country]"]');
      const zip = shippingForm.querySelector('[name="shipping_address[zip]"]');
      const submit = shippingForm.querySelector('[type="submit"]');

      if (!country?.value) {
        country?.focus();
        setShippingResult(shippingForm, 'Please select a country/region.');
        return;
      }

      const params = new URLSearchParams();
      params.append('shipping_address[country]', country.value);
      if (zip?.value.trim()) params.append('shipping_address[zip]', zip.value.trim());

      const originalText = submit?.textContent || 'Calculate';
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Calculating...';
      }
      setShippingResult(shippingForm, '');

      fetch(`${getShopifyRoute('/cart/shipping_rates.json')}?${params.toString()}`, {
        headers: { Accept: 'application/json' },
      })
        .then((response) => {
          if (!response.ok) throw new Error('Unable to calculate shipping rates.');
          return response.json();
        })
        .then((data) => {
          const rates = data.shipping_rates || [];
          if (!rates.length) {
            setShippingResult(shippingForm, 'No shipping rates found for this address.');
            return;
          }

          const ratesHtml = rates
            .map(
              (rate) =>
                `<li><span>${escapeHtml(rate.name || 'Shipping')}</span><strong>${escapeHtml(
                  formatShippingRate(rate)
                )}</strong></li>`
            )
            .join('');
          setShippingResult(shippingForm, `<ul>${ratesHtml}</ul>`);
        })
        .catch(() => {
          setShippingResult(shippingForm, 'Shipping rates could not be calculated right now.');
        })
        .finally(() => {
          if (submit) {
            submit.disabled = false;
            submit.textContent = originalText;
          }
        });
      return;
    }

    const form = event.target.closest('[data-skim1-discount-form]');
    if (!form) return;

    event.preventDefault();

    const input = form.querySelector('[name="discount"]');
    const code = input ? input.value.trim() : '';
    if (!code) {
      input?.focus();
      return;
    }

    const root = window.Shopify?.routes?.root || '/';
    const redirect = `${window.location.pathname}${window.location.search}`;
    window.location.href = `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirect)}`;
  });
})();
